type CrmCard = { showCondition?: (project: unknown) => boolean } | undefined

/** Типы CRM из белого списка онбординга, которые есть в connectorsList и проходят showCondition. */
export function getAvailableCrmTypes(
    crmSystems: string[],
    connectorsByType: Record<string, CrmCard>,
    project: unknown
): string[] {
    return crmSystems.filter(type => {
        if (!Object.prototype.hasOwnProperty.call(connectorsByType, type)) return false
        const connector = connectorsByType[type]
        return connector?.showCondition ? Boolean(connector.showCondition(project)) : true
    })
}
